/* Copyright (c) 2017 Backpack Health LLC */

import React from 'react'

import BackgroundFooter from './BackgroundFooter';

import './AppFrameNoSideNav.css';

const AppFrameNoSideNav = ({ SiteMap, children, onClickLogo }) => {
  return (
    <div className="cmp-appframe_no-sidenav">
      <div className="appframe-content">
        <div className="content is-centered">
          {children}
        </div>
        <div className="footer">
          <BackgroundFooter />
        </div>
      </div>
    </div>
  );
}

export default AppFrameNoSideNav;
